import * as React from 'react';
import { ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_REDO } from '@editor/src/img/pageIndex';

export const config = {
    id: ActionType.REDO,
    tipMsg: i18n.t('重做'),
    icon: TOOLBAR_REDO,
    shortcut: {
        win: 'Ctrl+Y',
        mac: '⌘+Y',
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
        shortcut: config.shortcut,
    },
];
